<template>
  <div id="app" class="app-container">
    <top-nav />
    <main class="page">
      <router-view />
    </main>
  </div>
</template>

<script>
import TopNav from "./components/TopNav.vue";

export default {
  name: "App",
  components: {
    TopNav,
  },
};
</script>

<style scoped>
#app {
  font-family: "haffer-light";
}

.app-container {
  min-height: 100vh;
  background-color: var(--color-paper);
}

.page {
  padding-top: var(--nav-height);
}
</style>
